import { render } from "./Pagination_principal.vue?vue&type=template&id=3f1c281d"
import script from "./Pagination_principal.vue?vue&type=script&lang=js"
export * from "./Pagination_principal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Sebastien.Ducharme/condamnation-datepicker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__